<template>
  <div >
    <div class="box-login">
      <p>
        <small>Defina uma nova senha para o seu acesso.</small>
      </p>
      <form label-width="120px" @keyup.enter='submit'>
        <el-row class="row-login">
          <el-col :span="24">
           <el-input type="password" prefix-icon="fas fa-lock" placeholder="Senha" v-model="password"></el-input>
          </el-col>
        </el-row>
        <el-row class="row-login">
          <el-col :span="24">
           <el-input type="password" prefix-icon="fas fa-lock" placeholder="Repetir Senha" v-model="re_password"></el-input>
          </el-col>
        </el-row>
        <el-row class="row-login">
          <el-col :span="24">
            <el-button type="success" @click='submit'>Atualizar Senha</el-button>
          </el-col>
        </el-row>
      </form>
      <small>
     
    </small>

    </div>
  </div>
</template>

<script>
import Store from '@/store'
import axios from 'axios'
import CryptoJS from 'crypto-js'


export default {
  data() {
      return {
          password: '',
          re_password: ''
        
      }
  },
  methods:{
    handleClick() {
        console.log('click');
    },
    submit(e){
      e.preventDefault()
      if(this.password.length > 7 && this.password == this.re_password)
      {
        global.Loading.begin(`Localizando seu cadastro`);
        const password = CryptoJS.SHA1(this.password);
        axios({
          method: 'post',
          url: `${global.base}/api/atualizar-senha/${this.$route.params.token}`,
          data: {
            password: password.toString(CryptoJS.enc.hex)
          },
          headers: { 'authorization': `bearer ${this.$store.state.session.jwt}` },
          }).then((r)=>{
            global.Loading.end();
            this.$alert(`Senha foi salva com sucesso`, 'Senha atualizada!!', {
              confirmButtonText: 'OK',
              callback: action => {
                this.$router.push("/p/login");
              }  
            });
          }).catch(()=>{
            global.Loading.end();
              this.$alert(`Não foi possível atualizar sua senha`, 'Erro!', {
              confirmButtonText: 'OK',
              callback: action => {
                
              }
            })
          })
      }else{
        this.$alert(`A senhas precisam ser iguais e devem ter no minimo 8 caracteres`, 'Error!', {
          confirmButtonText: 'OK',
          callback: action => {
            
          }
        })
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .box-login{
  padding:25px;
  background: #FFF;
  width: 400px;
  margin:auto;
  min-height:100px;

 }
 .row-login{
  margin:20px;
 }
</style>
